// Bengali names for 0–99. Index = numeric value.
const BN_NUMS = [
  'শূন্য','এক','দুই','তিন','চার','পাঁচ','ছয়','সাত','আট','নয়',
  'দশ','এগারো','বারো','তেরো','চোদ্দো','পনেরো','ষোলো','সতেরো','আঠারো','উনিশ',
  'বিশ','একুশ','বাইশ','তেইশ','চব্বিশ','পঁচিশ','ছাব্বিশ','সাতাশ','আটাশ','উনত্রিশ',
  'ত্রিশ','একত্রিশ','বত্রিশ','তেত্রিশ','চৌত্রিশ','পঁয়ত্রিশ','ছত্রিশ','সাতত্রিশ','আটত্রিশ','উনচল্লিশ',
  'চল্লিশ','একচল্লিশ','বিয়াল্লিশ','তেতাল্লিশ','চুয়াল্লিশ','পঁয়তাল্লিশ','ছেচল্লিশ','সাতচল্লিশ','আটচল্লিশ','উনপঞ্চাশ',
  'পঞ্চাশ','একান্ন','বায়ান্ন','তিপান্ন','চুয়ান্ন','পঞ্চান্ন','ছাপান্ন','সাতান্ন','আটান্ন','উনষাট',
  'ষাট','একষট্টি','বাষট্টি','তেষট্টি','চৌষট্টি','পঁয়ষট্টি','ছেষট্টি','সাতষট্টি','আটষট্টি','উনসত্তর',
  'সত্তর','একাত্তর','বাহাত্তর','তিয়াত্তর','চুয়াত্তর','পঁচাত্তর','ছিয়াত্তর','সাতাত্তর','আটাত্তর','উনআশি',
  'আশি','একাশি','বিরাশি','তিরাশি','চুরাশি','পঁচাশি','ছিয়াশি','সাতাশি','আটাশি','উননব্বই',
  'নব্বই','একানব্বই','বিরানব্বই','তিরানব্বই','চুরানব্বই','পঁচানব্বই','ছিয়ানব্বই','সাতানব্বই','আটানব্বই','নিরানব্বই',
];

// Convert 1–999 to Bengali words.
function upTo999(n) {
  if (n <= 0 || n > 999) return '';
  const parts = [];
  const h = Math.floor(n / 100);
  const rem = n % 100;
  if (h > 0) parts.push(BN_NUMS[h] + 'শো');
  if (rem > 0) parts.push(BN_NUMS[rem]);
  return parts.join(' ');
}

// Convert a crore count (1–999999) to Bengali words (e.g. 100 → "একশো", 1500 → "এক হাজার পাঁচশো").
function croreCount(c) {
  if (c <= 0) return '';
  const parts = [];
  if (c >= 1000) {
    parts.push(upTo999(Math.floor(c / 1000)) + ' হাজার');
    c = c % 1000;
  }
  if (c > 0) parts.push(upTo999(c));
  return parts.join(' ');
}

/**
 * Convert a number string (Bengali or English digits) to Bengali words.
 * Expresses all large amounts in কোটি (no অরব unit).
 * Returns '' for invalid / zero input.
 */
export function numberToBengaliWords(raw) {
  if (!raw && raw !== 0) return '';

  // Normalise Bengali digits → ASCII
  const enStr = String(raw).replace(/[০-৯]/g, (d) => '০১২৩৪৫৬৭৮৯'.indexOf(d));
  const cleaned = enStr.replace(/[^0-9.]/g, '');
  if (!cleaned) return '';

  const [intPart, decPart] = cleaned.split('.');
  let n = parseInt(intPart || '0', 10);
  if (isNaN(n) || n < 0) return '';
  if (n === 0 && !decPart) return '';

  const parts = [];

  // Crore (1,00,00,000) — absorbs what was previously "arab" too
  const crore = Math.floor(n / 10000000);
  n %= 10000000;
  if (crore > 0) parts.push(croreCount(crore) + ' কোটি');

  // Lakh (1,00,000)
  const lakh = Math.floor(n / 100000);
  n %= 100000;
  if (lakh > 0) parts.push(BN_NUMS[lakh] + ' লক্ষ');

  // Thousand (1,000)
  const thousand = Math.floor(n / 1000);
  n %= 1000;
  if (thousand > 0) parts.push(BN_NUMS[thousand] + ' হাজার');

  // Hundred (100)
  const hundred = Math.floor(n / 100);
  n %= 100;
  if (hundred > 0) parts.push(BN_NUMS[hundred] + 'শো');

  // 1–99
  if (n > 0) parts.push(BN_NUMS[n]);

  const intWords = parts.join(' ');

  // Decimal part → "দশমিক X" (e.g. .45 → দশমিক পঁয়তাল্লিশ)
  let decimalWords = '';
  if (decPart) {
    const decN = parseInt(decPart.slice(0, 2).padEnd(2, '0'), 10);
    if (decN > 0) decimalWords = BN_NUMS[decN];
  }

  if (intWords && decimalWords) return intWords + ' দশমিক ' + decimalWords;
  if (intWords) return intWords;
  return '';
}
